// extracted by mini-css-extract-plugin
export var activeDot = "_5y-c";
export var buttonContainer = "_5y-9";
export var channelButton = "_5y-a";
export var content = "_5y-0";
export var contentFull = "_5y-2";
export var contentThird = "_5y-1";
export var contentWrapper = "_5y-7";
export var description = "_5y-5";
export var image = "_5y-3";
export var imageContainer = "_5y-4";
export var selectButton = "_5y-d";
export var spinnerContainer = "_5y-b";
export var titleContent = "_5y-8";
export var titleWrapper = "_5y-6";